import paymentService from "../../service/payment.service";
import freightFinancialService from "../../service/freight-financial.service";

export async function sendFreightInvoiceBoletoFromPanel({
  freightId,
  freightData,
  record,
  shipperData,
  user,
  boletoFile,
  boletoAttachment,
  financialInstallments,
  installmentNumber,
  resolveUploadedBoletoAttachment,
}) {
  let resolvedAttachment = boletoAttachment;
  const resolvedInstallmentNumber =
    installmentNumber ?? record?.installmentNumber ?? 1;

  if (boletoFile && freightId) {
    const uploadResult = await freightFinancialService.uploadBoleto(
      freightId,
      boletoFile,
      {
        installmentNumber: resolvedInstallmentNumber,
        financialInstallments,
      },
    );
    resolvedAttachment = resolveUploadedBoletoAttachment(
      uploadResult,
      boletoFile,
    );
  }

  return paymentService.sendFreightControlBoletoEmail({
    freightId,
    freightData,
    record,
    shipperData,
    user,
    boletoAttachment: resolvedAttachment,
  });
}

export async function sendFreightInvoiceChargeFromPanel({
  freightId,
  freightData,
  record,
  shipperData,
  user,
}) {
  return paymentService.sendFreightControlChargeEmail({
    freightId,
    freightData,
    record,
    shipperData,
    user,
  });
}
